<template>
  <el-calendar v-model="value" class="medium" ref="calendar">
    <template #header="{date}">
      <span style="font-size: 24px; line-height: 40px">{{ date }}</span>
      <el-button-group>
        <el-button @click="selectDate('prev-month')">上个月</el-button>
        <el-button @click="selectDate('today')">今天</el-button>
        <el-button @click="selectDate('next-month')">下个月</el-button>
      </el-button-group>
    </template>
    <template #date-cell="{data}">
      <div class="dateDiv" :dataInfo="item=showWorkDate(data.day)">
        <div class="dateDivEdit" v-loading="dateLoading[data.day]" @click="confirmEdit(data)" v-if="!item?.past_date">
          <text class="dayDiv">{{ data.day.split('-').slice(1).join('-') }}</text>
          <div class="div-text">
            <text class="workDiv" v-if="item?.work_type==='work'">{{ "班" }}</text>
            <text class="holidayDiv" v-if="item?.work_type==='holiday'">{{ "节" }}</text>
            <text class="restDiv" v-if="item?.work_type==='weekend'">{{ "休" }}</text>
          </div>
        </div>
        <div class="pastDateDivEdit" v-loading="dateLoading[data.day]" v-if="item?.past_date">
          <text class="dayDiv">{{ data.day.split('-').slice(1).join('-') }}</text>
          <div class="div-text">
            <text class="workDiv" v-if="item?.work_type==='work'">{{ "班" }}</text>
            <text class="holidayDiv" v-if="item?.work_type==='holiday'">{{ "节" }}</text>
            <text class="restDiv" v-if="item?.work_type==='weekend'">{{ "休" }}</text>
          </div>
        </div>
      </div>
    </template>
  </el-calendar>
</template>


<script>

export default {
  name: "WorkDateManager",
  data() {
    return {
      value: new Date(),
      dateLoading: [],
      currentDay: false,
      dateMap: [],
    }
  },
  methods: {
    selectDate(value) {
      this.$refs.calendar.selectDate(value)
      this.getWorkDateList(this.value)
    },

    showWorkDate(day) {
      console.log(this.dateMap[day])
      if (this.dateMap[day] !== undefined) {
        return this.dateMap[day]
      }
      return ""
    },

    async getWorkDateList(date) {
      let params = {work_date:date}
      this.dateMap = await this.$http('oaWorkDateService.selectMonthData', params)
    },

    async confirmEdit(data) {
      if (!this.dateLoading[data.day]) {
        this.dateLoading[data.day] = true

        let params = {date:data.day}
        await this.$http('oaWorkDateService.updateWorkDate', params)
        this.$message.success("修改成功")
        await this.getWorkDateList(this.value)
        this.dateLoading[data.day] = false
      }

    },

  },

  created() {
    this.getWorkDateList(this.value)
  }

}
</script>

<style scoped>
:deep(.el-calendar-table td.is-today) {
  background-color: #d9ecff;
}

:deep(.el-calendar-table .el-calendar-day) {
  padding: 0px;
}

.medium ::v-deep(.prev) {
  visibility: hidden !important;
}

.medium ::v-deep(.next) {
  display: none !important;
}

.medium ::v-deep(.el-calendar-table td) {
  border: solid 1px #ebeef5 !important;
}

.dateDiv {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.dateDivEdit {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pastDateDivEdit {
  background-color: whitesmoke;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.dayDiv {
  width: 70px;
  height: 25px;
  text-align: center;
}

.div-text {
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.restDiv {
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: rgb(250, 124, 77);
}

.workDiv {
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  color: #909399;
  background-color: #e5e5e5;
}

.holidayDiv {
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #42b983;
}

.el-calendar-table {
  font-size: 18px;
}
</style>
